// Resolve the avatar source for an Identity / IdentificationDocument.
//
// Current convention: the `extract_identity_face` step writes an absolute
// API URL (`/api/v1/files/<s3_key>`) into `photoPath` — pass it through
// unchanged. Pre-v2 local-filesystem paths (`./data/faces/...`) pointed at
// a static mount that no longer exists and cannot be served; render no
// image for them instead of a guaranteed-404 link.
export function getImageUrl(photoPath: string | undefined): string | null {
  if (!photoPath) return null
  if (photoPath.startsWith('/') || /^https?:\/\//.test(photoPath)) {
    return photoPath
  }
  return null
}
